import { Grid, GridItem } from "@innovationnorway/lighthouse-components";
import React from "react";
import { ApplicationV2 } from "../../../main/models/application-v2";
import { FetchStatus } from "../../../main/models/fetch-status";
import { FormStatus } from "../../../main/models/form-status";
import { FormTypeV2 } from "../../../main/models/form-type-v2";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import useWindowSize from "../../../utils/windowsSize";
import { useLayout } from "../../hooks/useLayout";
import InfoCard, { InfoLineProps } from "../infoCard/infoCard";
import MyTasks from "../myTasks/myTasks";
import "./applicationContainer.scss";

interface ApplicationContainerProps {
  activeApplication?: ApplicationV2;
  contactInfoLines: InfoLineProps[];
  setOpenEditContactInfoModal: (open: boolean) => void;
  fetchStatus: FetchStatus;
}

const ApplicationContainer = ({
  activeApplication,
  contactInfoLines,
  fetchStatus,
  setOpenEditContactInfoModal
}: ApplicationContainerProps) => {
  const { translations } = useLayout();
  const windowSize = useWindowSize();
  const breakGrid = windowSize.width < 1424;

  const keyInfoLines: InfoLineProps[] = [
    {
      id:
        translations.applicationsTableHeaderStatus +
        (activeApplication?.status !== undefined ? translations[`applicationsStatus${activeApplication?.status}`] : ""),
      textKey: translations.applicationsTableHeaderStatus,
      value:
        activeApplication?.status !== undefined ? translations[`applicationsStatus${activeApplication?.status}`] : ""
    },
    {
      id: translations.created + activeApplication?.createdOn,
      textKey: translations.created,
      dateValue: activeApplication?.createdOn
    }
  ];

  const keyInfoButtonOnClick = () => {
    sendSiteimproveEvent(
      `MyPage-openApplicationBeta`,
      "openApplicationKeyInfo",
      "Open application in key info clicked"
    );
    window.open(activeApplication?.applicationUrl);
  };

  return (
    <Grid>
      <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
        <div className="ApplicationContainer__tasks">
          <MyTasks
            tasks={activeApplication?.tasks}
            projectTitle={activeApplication?.title || ""}
            newTasks={activeApplication?.tasks?.filter((task) => task.isNew)}
            fetchStatus={fetchStatus}
          />
        </div>
      </GridItem>

      <GridItem spanLarge={breakGrid ? 12 : 6} spanMedium={12} spanSmall={4}>
        <InfoCard
          heading={translations.keyInformation}
          infoLines={keyInfoLines}
          dummyText={translations.keyInfoDummyText}
          buttonText={
            activeApplication?.formType === FormTypeV2.GreenPlatform
              ? translations.greenPlatformButtonLabel
              : activeApplication?.formType === FormTypeV2.FastForward
              ? translations.seeInquiry
              : activeApplication?.status === FormStatus.Draft || activeApplication?.status === FormStatus.Returned
              ? translations.continueApplication
              : translations.openApplication
          }
          buttonOnClick={keyInfoButtonOnClick}
        />
      </GridItem>
      <GridItem spanLarge={breakGrid ? 12 : 6} spanMedium={12} spanSmall={4}>
        <InfoCard
          heading={translations.editContactHeader}
          infoLines={contactInfoLines}
          buttonText={translations.change}
          buttonOnClick={() => {
            setOpenEditContactInfoModal(true);
          }}
        />
      </GridItem>
    </Grid>
  );
};

export default ApplicationContainer;
